/**
 * 공지 푸시 발송 팝업 (/adm/notice/push?…) — 대상 요약을 보고 [푸시 알림] 으로 큐에 싣는다
 * ($j.Pages.Admin.NoticePush / body data-page-name="NoticePush")
 */
export default class NoticePush {
    initialize() {
        $('#btnSendPush').on('click', function () { sendPush(Number(this.dataset.n)); });
    }
}

function sendPush(notinum){
    $.ajax({
        type: 'POST',
        url:  '/adm/ajax/notice/broadcast',
        data: { notinum: notinum },
        success: function(){
            alert('전송이 완료되었습니다.');
        }
    });
}
